import React from 'react';
import { findDOMNode } from 'react-dom';
import { Loader, MediaItemErrorMsg } from 'wix-rich-content-ui-components';
import { VideoViewer } from '../viewer/video-viewer.js';
import { s as styles } from '../default-video-styles-cfb6dfa5.js';
import 'wix-rich-content-common';
import '../IframePlayer.js';
import '../video-viewer-33e9b44b.js';
import '../style-inject.es-746bb8ed.js';
import '../reactPlayerWrapper.js';
import 'prop-types';
import 'react-player';
import '../constants.js';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class VideoComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleReady = (player) => {
      if (!this.state.isLoaded) {
        this.setState({ isLoaded: true });
      }
      this.handleDuration(player);
    };
    this.handleDuration = (player) => {
      setTimeout(() => {
        const duration = player.getDuration();
        if (duration) {
          this.saveDurationToData(duration);
        } else {
          this.setState({ shouldRenderDurationFix: true });
        }
      }, 3e3);
    };
    this.renderLoader = () => {
      var _a, _b;
      const isCustomVideo = (_b = (_a = this.props.componentData.video) == null ? void 0 : _a.src) == null ? void 0 : _b.id;
      return /* @__PURE__ */ React.createElement("div", { className: styles.videoOverlay }, /* @__PURE__ */ React.createElement(
        Loader,
        {
          type: "medium",
          isVerySlowFakeLoader: isCustomVideo,
          percent: this.props.loadingPercentage,
          disableProgress: !this.props.isLoading && !this.state.isLoaded
        }
      ));
    };
    this.saveDurationToData = (duration) => {
      const { componentData, updateAttributes } = this.props;
      updateAttributes(__spreadProps(__spreadValues({}, componentData), { video: __spreadProps(__spreadValues({}, componentData.video || {}), { duration }) }));
    };
    this.renderPlayer = () => {
      const { componentData, settings, nodeId } = this.props;
      return /* @__PURE__ */ React.createElement(
        VideoViewer,
        {
          componentData,
          settings,
          onReady: this.handleReady,
          isLoaded: this.state.isLoaded,
          key: this.state.iosFixKey,
          nodeId,
          disabled: true
        }
      );
    };
    this.renderPlayerDurationFix = () => {
      const { componentData, settings, nodeId } = this.props;
      let timeoutId;
      const onReady = (player) => {
        const internalPlayer = player.getInternalPlayer();
        if (internalPlayer.play) {
          internalPlayer.play();
        } else {
          timeoutId = setTimeout(() => {
            var _a;
            (_a = player.getInternalPlayer()) == null ? void 0 : _a.play();
          }, 1e4);
        }
      };
      return /* @__PURE__ */ React.createElement("div", { className: styles.hide_duration }, /* @__PURE__ */ React.createElement(
        VideoViewer,
        {
          componentData,
          settings,
          onReady,
          onDuration: (duration) => {
            this.setState({ shouldRenderDurationFix: false });
            this.saveDurationToData(duration);
            clearTimeout(timeoutId);
          },
          nodeId,
          muted: true
        }
      ));
    };
    this.state = {
      isLoaded: false,
      iosFixKey: 1
    };
  }
  componentDidMount() {
    this.handlePlayerFocus();
  }
  componentDidUpdate() {
    this.handlePlayerFocus();
  }
  handlePlayerFocus() {
    var _a, _b;
    const element = (_b = (_a = findDOMNode(this)) == null ? void 0 : _a.querySelector) == null ? void 0 : _b.call(_a, "iframe, video");
    if (element) {
      element.tabIndex = -1;
    }
  }
  render() {
    const {
      t,
      componentData: { error },
      isLoading
    } = this.props;
    const { isLoaded, shouldRenderDurationFix } = this.state;
    const loading = isLoading || !isLoaded;
    return /* @__PURE__ */ React.createElement("div", { "data-hook": "videoPlayer", className: styles.video_container }, /* @__PURE__ */ React.createElement("div", { className: styles.video_overlay }), this.renderPlayer(), shouldRenderDurationFix ? this.renderPlayerDurationFix() : null, loading && !error && this.renderLoader(), error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t }));
  }
}

export { VideoComponent };
//# sourceMappingURL=video-component.js.map
